import React, { useContext } from 'react'
import { Paragraph } from '@scentregroup/ui'
import { FeatureFlagsContext } from '../../context'

interface NotificationProps {
  className?: string
  message?: string
}

const EventNotification: React.FunctionComponent<NotificationProps> = ({
  className,
  message = '*Upcoming events are subject to change',
}) => {
  const IS_EVENT_NOTY = useContext(FeatureFlagsContext)
    .NEXT_PUBLIC_FEAT_FLAG_EVENT_NOTY

  if (IS_EVENT_NOTY) {
    return (
      <Paragraph type="large" className={className}>
        {message}
      </Paragraph>
    )
  }

  return null
}

export default EventNotification
